import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { login, getUserPhoto } from "@/apis/common"
import { queryRoleTypeByStudioId } from "@/apis/activity/admin"
import { setToken } from '@/utils'

Vue.use(Vuex);

const { hostname } = window.location;
const CONFIG_SET = 'CONFIG_SET'
export default new Vuex.Store({
    state: {
       
        headerObj: {
            title: '',
            nav: []
        },
        breadcrumbTips: '',
        breadcrumbNav: [],
        sidemenuNav: [],
        getProjectName:"",
        accessToken: '',
        ms_username: {},
        config: {
            UPLOAD_SDK: 'talkweb-huawei',
            // OPEN_API_URL: 'https://openapi.edu.yiyang.gov.cn',
            OPEN_API_URL: 'https://openapi-dev.talkedu.cn',
            SGKT_URL: '/api',
            BASE_CLIENT_ID:'ba1c41c6-774b-11eb-bd4a-0242ac110012',
            domainName: hostname === 'localhost' ? 'sgkt-dev.talkedu.cn' : hostname,
            quitPath:'http://localhost:8080/review/ability-compet/activity/list',
            isNewflat: "false",//登录退出使用的是新平台还是老平台
        }
    },
    mutations: {
        [CONFIG_SET](state, config) {
            Object.assign(state.config, config.data)
        },
        SET_HEADEROBJ: (state, obj) => {
            Object.assign(state.headerObj, obj)
        },
        SET_USERINFO: (state, USERINFO) => {
            state.ms_username = USERINFO;
        },
        SET_TOKEN: (state, TOKEN) => {
            state.accessToken = TOKEN;
        },
        getBreadcrumbNav(state, rows) {
            state.breadcrumbNav = rows;
        },
        getSidemenuNav(state, rows) {
            state.sidemenuNav = rows
        },
        getBreadcrumbTips(state, text) {
            state.breadcrumbTips = text
        },
        getProjectNameF(state, text) {
            state.getProjectName = text
        }
    },
    actions: {
        async [CONFIG_SET]({ commit }) {
            if(hostname !== 'localhost') {
                await axios.get(
                    `/sgkt/config.json?nowTime=${new Date().getTime()}`
                ).then(response => {
                    commit(
                        CONFIG_SET,
                        response.data
                    )
                    setToken('config-config', response.data);
                }).catch(error => {
                    throw new Error(error)
                })
            }
        },
        login({ commit }, params) {
            return new Promise((resolve, reject) => {
                login(params)
                    .then(response => {
                        let { result } = response;
                        let userImg = getUserPhoto() + result.userId;
                        result.userImg = userImg || null;
                        commit("SET_USERINFO", result);
                        commit('SET_TOKEN', result.accessToken)
                        setToken("accessToken", result.accessToken);
                        setToken("idToken", result.idToken);
                        setToken("ms_username", JSON.stringify(result));
                        setToken('recCode', result.userMobile);
                        resolve(true);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        adminPower({ commit }, params) {
            return new Promise((resolve, reject) => {
                queryRoleTypeByStudioId(params)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js